/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { IHostnameParam } from 'types/IHostnameParam';
import { IProduct } from 'types/IProduct';
import { IProductsFilter } from 'types/IProductsFilter';

import { api } from 'services/api';

export type TGetProductsParams = IHostnameParam & {
  search?: string;
  categories?: string;
  sortBy?: string;
  brand?: string;
  attributes?: string;
  page?: number;
};

export type TGetProductsFiltersParams = IHostnameParam & {
  search?: string;
  categories?: string;
};

export async function getProducts(
  config?: TGetProductsParams
): Promise<IProduct[]> {
  const { hostname, categories, search, sortBy, brand, attributes } =
    config || {};

  const response = await api.get<IProduct[]>('/products', {
    params: {
      status: 'active',
      search,
      categories,
      sortBy,
      shouldGroupVariations: true,
      brand,
      showBrand: true,
      attributes,
    },
    ...(hostname ? { headers: { 'x-domain': hostname } } : {}),
  });

  return response.data;
}

export async function getProductsFilters(
  config?: TGetProductsFiltersParams
): Promise<IProductsFilter[]> {
  const { hostname, categories, search } = config || {};

  const response = await api.get<IProductsFilter[]>('/products/filters', {
    params: {
      status: 'active',
      search,
      categories,
    },
    ...(hostname ? { headers: { 'x-domain': hostname } } : {}),
  });

  return response.data;
}

export type TGetProductByTagParams = IHostnameParam & {
  tag: string;
};

export async function getProductByTag(
  config: TGetProductByTagParams
): Promise<IProduct> {
  const { hostname, tag } = config;

  const response = await api.get<IProduct>(`/products/tag/${tag}`, {
    params: {
      status: 'active',
      shouldGroupVariations: true,
    },
    ...(hostname ? { headers: { 'x-domain': hostname } } : {}),
  });

  return response.data;
}
